import Vue from 'vue'
import ElementUI from 'element-ui';
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css';
import router from './router.js';
import {
  registerConfig
} from './index'
import App from './App.vue'
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(window.AVUE);

registerConfig({
  config: {
    keys: '联系Avue客服获取'
  },
  router,
  axios
})
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')